// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3P6_7","productName":"Table_productName__2JzC8"};